import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const configurationPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Configuration },
    { actions: [Actions.read], subject: Models.Configurations },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Configuration },
    { actions: [Actions.read], subject: Models.Configurations },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Configuration },
    { actions: [Actions.read], subject: Models.Configurations },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.Configuration },
    { actions: [Actions.read], subject: Models.Configurations },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
